import { Link } from 'react-router-dom';
import classNames from 'classnames';
import React from 'react';

import * as FeatherIcon from 'react-feather';

const MenuItemLink = ({ item, className }) => {
    return (
        <Link to={item.path} className={classNames('side-nav-link-ref', 'side-sub-nav-link', className)}>
            <FeatherIcon.Grid size={10} className="my-auto" />
            {item.badge && <span className={`font-size-12 badge badge-${item.badge.variant} float-end`}>{item.badge.text}</span>}
            <span> {item.name} </span>
        </Link>
    );
};

export default MenuItemLink;
